import axios, { AxiosResponse } from 'axios'
import { API_ROOT } from 'config'
import { getLanguage } from 'store/locale/utils'
import { userManager } from 'scenes/authentication/oicd'

export enum REQUEST_METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export const getDefaultHeaders = (contentType?: string) => {
  return {
    'Content-Type': contentType || 'application/json',
    'Accept-Language': getLanguage(),
  }
}

const getAuthHeaders = async () => {
  const user = await userManager.getUser()
  if (!user) {
    return {}
  }

  return {
    Authorization: `Bearer ${user.access_token}`,
    'X-ID-Token': user.id_token,
  }
}

const paramsSerializer = (params: Record<string, unknown>) => {
  const searchParams = new URLSearchParams()

  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null) {
          searchParams.append(key, String(item))
        }
      })
      return
    }

    searchParams.append(key, String(value))
  })

  return searchParams.toString()
}

const apiRequest = async (method: REQUEST_METHOD, config: APIRequest) => {
  const { url, params, data, contentType } = config

  return axios.request({
    url: `${API_ROOT}${url}`,
    method,
    responseType: contentType ? 'blob' : 'json',
    headers: {
      ...getDefaultHeaders(contentType),
      ...(await getAuthHeaders()),
    },
    params,
    paramsSerializer,
    data,
  })
}

export const apiGET = (config: APIRequest): Promise<AxiosResponse> => {
  return apiRequest(REQUEST_METHOD.GET, config)
}

export const apiPOST = (config: APIRequest): Promise<AxiosResponse> => {
  return apiRequest(REQUEST_METHOD.POST, config)
}

export const apiPUT = (config: APIRequest): Promise<AxiosResponse> => {
  return apiRequest(REQUEST_METHOD.PUT, config)
}

export const apiDELETE = (config: APIRequest): Promise<AxiosResponse> => {
  return apiRequest(REQUEST_METHOD.DELETE, config)
}

export const apiPATCH = (config: APIRequest): Promise<AxiosResponse> => {
  return apiRequest(REQUEST_METHOD.PATCH, config)
}
